<template>
  <div id="widget-faq">
    <h2 class="subtitle is-3" v-html="$t('widget_details.faq')"></h2>
    <div class="columns">
      <div class="column is-12">
        <b-collapse
          animation="slide"
          v-for="(collapse, index) of widget.collapses"
          :key="index"
          :open="false"
          @open="isOpen = index"
          class="card"
        >
          <template #trigger="props">
            <div role="button" tabindex="0" :id="'faq'+index" @keyup.enter="onEnter" class="card-header">
              <p
                v-html="
                  $i18n.locale == 'fr' ? collapse.title_fr : collapse.title
                "
                class="card-header-title is-size-6 has-text-weight-semibold"
              ></p>
              <a class="card-header-icon">
                <b-icon
                  type="is-link"
                  :icon="props.open ? 'caret-up' : 'caret-down'"
                >
                </b-icon>
              </a>
            </div>
          </template>
          <div class="card-content">
            <div
              v-html="$i18n.locale == 'fr' ? collapse.text_fr : collapse.text"
              class="content"
            ></div>
          </div>
        </b-collapse>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "WidgetFAQ",
  props: {
    widget: { type: Object, required: true }
  },
  data: function() {
    return {
      isOpen: 0
    };
  },
  methods: {
    onEnter(event) {
      if (event) {
        document.getElementById(event.target.id).click()
      }
    }
  }
};
</script>

<style>
.collapse > .collapse-trigger {
  position: relative;
}
</style>
